// extracted by mini-css-extract-plugin
module.exports = {"buttons":"row-actions_buttons__EEGdx offer-list_buttons__1T5Mv","delete":"row-actions_delete__rOGrJ offer-list_delete__1OWJd","archive":"row-actions_archive__2g3yY"};